import { FiltersGroups, FilterValueType } from 'constants/filters';
import { ISelectOption } from 'types/select';

export enum FiltersTypes {
  Input = 'input',
  Select = 'select',
  DatePicker = 'datePicker',
}

interface IFilterAttributes {
  label: string;
  apiParam: string;
  valueType?: FilterValueType;
}

export interface IFilter {
  urlKey: string;
  label: string;
  type: FiltersTypes;
}

export type IFiltersGroups = {
  [key in FiltersGroups]: IFilter[];
};

export type IFiltersAttributes = Record<string, Record<string, IFilterAttributes>>;

export type IFilterSelectOptions = Record<string, Record<string, ISelectOption<string | number>[]>>;
